/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Status_ShippedInputs */

const en_us2_community_status_shipped = /** @type {(inputs: Community_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already in the app`)
};

const pt_br2_community_status_shipped = /** @type {(inputs: Community_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já no app`)
};

const es_419_community_status_shipped = /** @type {(inputs: Community_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya en la app`)
};

const pt_pt2_community_status_shipped = /** @type {(inputs: Community_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já na app`)
};

const fr_fr2_community_status_shipped = /** @type {(inputs: Community_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déjà dans l'appli`)
};

const de_de2_community_status_shipped = /** @type {(inputs: Community_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schon in der App`)
};

const it_it2_community_status_shipped = /** @type {(inputs: Community_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Già nell'app`)
};

/**
* | output |
* | --- |
* | "Already in the app" |
*
* @param {Community_Status_ShippedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_status_shipped = /** @type {((inputs?: Community_Status_ShippedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Status_ShippedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_status_shipped(inputs)
	if (locale === "es-419") return es_419_community_status_shipped(inputs)
	if (locale === "pt-PT") return pt_pt2_community_status_shipped(inputs)
	if (locale === "fr-FR") return fr_fr2_community_status_shipped(inputs)
	if (locale === "de-DE") return de_de2_community_status_shipped(inputs)
	if (locale === "it-IT") return it_it2_community_status_shipped(inputs)
	return en_us2_community_status_shipped(inputs)
});
export { community_status_shipped as "community.status_shipped" }